/**
 * Process JSON for contract analsis plan
 * @param {Array} contractBreakdown - Array of JSON file objects
 * @param {string} input - User input text
 * @param {Array} uploadedImages - Uploaded images
 * @returns {Object} - Object containing processed JSON files and messages
 */
export const processContractAnalysisData = (
  contractBreakdown,
  input,
  uploadedImages
) => {
  const proxyData = contractBreakdown[0].data.proxy;
  const implementationData = contractBreakdown[0].data.implementation;

  let proxyContext = '';
  if (proxyData) {
    proxyContext += `Proxy Contract Details: \n`;
    proxyContext += JSON.stringify(proxyData, null, 2);
    proxyContext += '\n';
  }

  let implementationContext = '';
  if (implementationData) {
    implementationContext += `Implementation Contract Details: \n`;
    implementationContext += JSON.stringify(implementationData, null, 2);
    implementationContext += '\n';
  }

  // Create first system message with original JSON data
  const systemDataMessage = {
    role: 'user',
    content: `
      Instructions:
      
      Analyze this Blockscope Contract Breakdown to understand the contract's proxy and implementation details.
  
      ${proxyContext}
      ${implementationContext}
      `,
  };

  // Create user message
  const userMessage = {
    role: 'user',
    content: [
      {
        type: 'text',
        text: input, // inputmessage is fetched from actionplan default
      },
      ...(uploadedImages
        ? uploadedImages.map((m) => ({ type: 'image', image: m[0] }))
        : []),
    ],
  };

  return {
    messages: {
      dataMessages: [systemDataMessage],
      userMessage,
    },
  };
};

